import { useEffect } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';

function Account() {
  const userContext = useContext(UserContext);

  useEffect(() => {
    console.log("abc4 Account context: ", userContext);
  }, []);

  return (
    <BasicLayout>
      <div>
        <h1>Profile</h1>
        {userContext?.store && (
          <div>
            <h2>Store</h2>
            <p>{userContext.store?.name}</p>
          </div>
        )}
        {userContext?.sellingLimit && (
          <div>
            <h2>Selling Limit</h2>
            <p>{userContext.sellingLimit}</p>
          </div>
        )}
        {userContext?.inventory && (
          <div>
            <h2>Inventory</h2>
            <p>{JSON.stringify(userContext.inventory)}</p>
          </div>
        )}
      </div>
    </BasicLayout>
  );
}

export default Account;
